import { MaestroTaskProgress } from '@automata/api/apiSchemas';
import Stack from '@mui/material/Stack';

import TooltipKeyValuePair from './TooltipKeyValuePair';
import TooltipBase from '../../../components/Tooltip/TooltipBase';
import { TaskLabware } from '../../../types';

type Props = {
  maestroTaskProgress: MaestroTaskProgress;
  maestroTaskLabware: TaskLabware;
  svgWidth: number;
  svgHeight: number;
};

const LabwareViewTooltip = ({
  maestroTaskProgress,
  maestroTaskLabware,
  svgHeight,
  svgWidth,
}: Props) => {
  const gap = 2;
  return (
    <TooltipBase svgHeight={svgHeight} svgWidth={svgWidth}>
      <Stack gap={gap} direction="row">
        <Stack gap={gap}>
          <TooltipKeyValuePair
            keyText="Instrument name"
            valText={maestroTaskProgress.task.instrument.name}
          />
          <TooltipKeyValuePair
            keyText="Labware"
            valText={maestroTaskLabware.label}
          />
        </Stack>
        <Stack>
          <TooltipKeyValuePair
            keyText="Action"
            valText={maestroTaskProgress.task.action}
          />
        </Stack>
      </Stack>
    </TooltipBase>
  );
};

export default LabwareViewTooltip;
